/* ======================================================================== */
/* 3. PJAX Finish Loading */
/* ======================================================================== */
function PJAXFinishLoading(data) {

	return new Promise(function (resolve, reject) {

		// Transition ended event
		window.dispatchEvent(new CustomEvent('arts/barba/transition/end'));

		window.SMController.enabled(true);
		window.SMController.update(true);
		window.$backgrounds.removeClass('selected active');
		window.$header.removeClass('header_lock-submenus');
		window.InteractiveCursor.finishLoading();
		lockScroll(false);

		TweenMax.to(window.$spinner, 1.2, {
			autoAlpha: 0
		});

		TweenMax.set(window.$preloader, {
			autoAlpha: 0
		});

		TweenMax.set(window.$wrapperBackgrounds, {
			autoAlpha: 0,
			zIndex: -1,
			clearProps: 'width,height,left,right,top,bottom,backgroundColor',
		});

		TweenMax.set(window.$backgroundsOverlay, {
			autoAlpha: 1
		});

		TweenMax.set(window.$backgrounds, {
			transition: '',
			clearProps: 'transform,width,height',
		});

		$('.dialog-lightbox-widget').remove();

		setTimeout(function () {
			window.$overlay.removeClass('intransition lockhover opened');
		}, 300);

		if (window.location.hash && !window.location.hash.startsWith('#elementor-action')) {
			setTimeout(() => {
				try {
					var
						$scrollElement = $(window.location.hash),
						time = 800;

					if ($scrollElement.length) {
						var offsetY = $scrollElement.offset().top;

						if (typeof window.SB !== 'undefined') {
							window.SB.scrollIntoView($scrollElement.get(0));
								// window.SB.scrollTo(0, offsetY, time);
							} else {
								$('html, body').animate({
									scrollTop: offsetY
								}, time);
							}

					}
				} catch (error) {
					console.warn(error);
				}
			}, 1000);
		}

		resolve(true);

	});

}
